export type ChamberStaffAccountStatus =
  | "ACTIVE"
  | "SUSPENDED"
  | "DELETION_PENDING";

export type ChamberStaffCredentialDeliveryStatus =
  | "NOT_SENT"
  | "SUPPRESSED"
  | "SENT"
  | "FAILED"
  | "UNKNOWN";

export type PermissionPlatform =
  | "chamberMemberPro"
  | "chamberPerksAppAdminConsole";

export type PermissionSelection = {
  chamberMemberPro: string[];
  chamberPerksAppAdminConsole: string[];
};

export type StaffUserFormValue = {
  firstName: string;
  lastName: string;
  jobTitle: string;
  email: string;
  permissions: PermissionSelection;
};

export type ChamberStaffUserViewModel = StaffUserFormValue & {
  id: string;
  accountStatus: ChamberStaffAccountStatus;
  credentialDeliveryStatus: ChamberStaffCredentialDeliveryStatus;
  credentialsLastSentAtUtcMilli?: number | null;
  credentialsLastDownloadedAtUtcMilli?: number | null;
  lastLoginAtUtcMilli?: number | null;
  createdAtUtcMilli: number;
  updatedAtUtcMilli: number;
  deletedAtUtcMilli?: number | null;
};

export type CmpUserActivityViewModel = {
  id: string;
  actorUserId: string;
  actorDisplayName: string;
  relatedRecordId?: string | null;
  relatedRecordDisplayName?: string | null;
  section: string;
  action: string;
  activityDetails: string;
  createdAtUtcMilli: number;
};

export const EMPTY_PERMISSION_SELECTION: PermissionSelection = {
  chamberMemberPro: [],
  chamberPerksAppAdminConsole: [],
};

export const EMPTY_STAFF_USER_FORM_VALUE: StaffUserFormValue = {
  firstName: "",
  lastName: "",
  jobTitle: "",
  email: "",
  permissions: EMPTY_PERMISSION_SELECTION,
};
